export default __webpack_public_path__ + "static/media/catrina 2.0d703184.png";